import type { AllRouteEndpoints } from "../routeTypes";

export const companiesCompanyIdMobileAppLinkingConfigs = "/companies/:company_id/mobile_app_linking_configs";

export const postCompaniesCompanyIdMobileAppLinkingConfigsCacheKeys: AllRouteEndpoints[] = [
  companiesCompanyIdMobileAppLinkingConfigs,
];
